// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__T6TTI","clickEffect":"styles_clickEffect__ER2J0","pulse":"styles_pulse__BGNvs"};